import { UserStatus } from "../enumerations";

export class User {
	public static readonly $type: string = "User";
	public readonly $type: string = User.$type;

	public id?: number;
	public username: string = "";
	public firstName: string = "";
	public lastName: string = "";
	public email: string = "";
	public status!: UserStatus;

	public constructor(username: string = "", firstName: string = "", lastName: string = "", email: string = "") {
		this.username = username;
		this.firstName = firstName;
		this.lastName = lastName;
		this.email = email;
	}
}
